import React from 'react';
import { AuthProvider } from '@app/react-common/auth/AuthContext';
import { AppProvider } from '@app/react-common/AppContext';
import { StoreProvider } from '@app/react-common/StoreContext';
import { Router } from './router/Router';
import { Shop } from '@pdqdev/pdq-shared/dist/entities/Shop';
import { Observable, Subject } from 'rxjs';
import { AngularAction } from '../../checkout/react/models/AngularAction';
import { IExtensionGroup } from '../../extension-groups/models/extension-group.models';
import { FeatureFlag } from '@app/core/services/feature-flags/feature-flag.model';

interface AbTestingProps {
  jwtToken: string;
  shop$: Observable<Shop>;
  extensions$: Observable<any[]>;
  extensionGroups$?: Observable<IExtensionGroup[]>;
  angularRoutingSubject: Subject<string>;
  angularActionSubject: Subject<AngularAction>;
  isFeatureFlagEnabled$: (flag: FeatureFlag) => Observable<boolean>;
}

export const AbTesting = ({
  jwtToken,
  shop$,
  extensions$,
  extensionGroups$,
  angularRoutingSubject,
  angularActionSubject,
  isFeatureFlagEnabled$,
}: AbTestingProps) => {
  return (
    <React.Suspense fallback={<div>Loading...</div>}>
      <AuthProvider authToken={jwtToken}>
        <StoreProvider extensions$={extensions$} extensionGroups$={extensionGroups$}>
          <AppProvider
            shop$={shop$}
            angularRoutingSubject={angularRoutingSubject}
            angularActionSubject={angularActionSubject}
            isFeatureFlagEnabled$={isFeatureFlagEnabled$}>
            <Router />
            <div id="modal-root"></div>
          </AppProvider>
        </StoreProvider>
      </AuthProvider>
    </React.Suspense>
  );
};
